import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export const AnnouncementBox = ({ data }) => {
  const [isVisible, setIsVisible] = useState(false);
  const announcementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Optional: Stop observing after animation triggers once
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2, // Trigger when 20% of the element is visible
        rootMargin: '0px 0px -50px 0px' // Trigger slightly before the element is fully visible
      }
    );

    if (announcementRef.current) {
      observer.observe(announcementRef.current);
    }

    return () => {
      if (announcementRef.current) {
        observer.unobserve(announcementRef.current);
      }
    };
  }, []);

  return (
    <div 
      id="announcement" 
      className="announcement-section"
      ref={announcementRef}
    >
      <div className="container">
        <div className={`announcement-box ${isVisible ? 'fade-in' : 'fade-out'}`}>
          <div className="announcement-content">
            <h2>{data ? data.title : "Advanced AI Models for Statistical Analysis"}</h2>
            <p>
              {data ? data.description : "Our most powerful regression models yet, pushing the frontier for statistical analysis and data science—enabling PrioriAI to handle complex datasets and provide insights across multiple analytical frameworks."}
            </p>
            <Link to="/platform" className="announcement-btn">
              {data ? data.buttonText : "Try our models"}
            </Link>
          </div>
          
          <div className="announcement-cards">
            {data && data.cards ? data.cards.map((card, index) => (
              <div key={index} className="feature-card" style={{ animationDelay: `${index * 0.2}s` }}>
                <div className="feature-card-header">
                  <span>{card.subtitle}</span>
                  <h3>{card.title}</h3>
                </div>
                <div className="feature-card-arrow"></div>
              </div>
            )) : (
              <>
                <div className="feature-card" style={{ animationDelay: '0s' }}>
                  <div className="feature-card-header">
                    <span>Model details</span>
                    <h3>Linear Regression</h3>
                  </div>
                  <div className="feature-card-arrow"></div>
                </div>
                <div className="feature-card" style={{ animationDelay: '0.2s' }}>
                  <div className="feature-card-header">
                    <span>Model details</span>
                    <h3>Advanced Analytics</h3>
                  </div>
                  <div className="feature-card-arrow"></div>
                </div>
                <div className="feature-card" style={{ animationDelay: '0.4s' }}>
                  <div className="feature-card-header">
                    <span>Model details</span>
                    <h3>Time Series Forecasting</h3>
                  </div>
                  <div className="feature-card-arrow"></div>
                </div>
                <div className="feature-card" style={{ animationDelay: '0.6s' }}>
                  <div className="feature-card-header">
                    <span>Model details</span>
                    <h3>Classification Models</h3>
                  </div>
                  <div className="feature-card-arrow"></div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};